import BaseModel from "./BaseModel";

export enum GroupTypeEnum {
    APARTMENT = 'apartment',
}

export class UserGroup extends BaseModel {
    id: number;
    externalId?: number;
    groupType: GroupTypeEnum;
    accountId: number;
    label: string;
    description: string;

    static __dates = []; //["createdAt", "startDate", "endDate"];

    constructor(data) {
        super(data, UserGroup.__dates);

        this.id = data.id;
        this.externalId = data.externalId;
        this.groupType = data.groupType;
        this.accountId = data.accountId;
        this.label = data.label;
        this.description = data.description;
    }

    /** Sort list of user groups by label */
    static sortUserGroupsByLabel(userGroups: UserGroup[]) {
        userGroups.sort((a, b) => a.label.toLocaleLowerCase().localeCompare(b.label.toLocaleLowerCase()));
    }

    /** Sort list of user group table rows by label */
    static sortUserGroupTableRowsByLabel(userGroups: UserGroupTableRow[]) {
        userGroups.sort((a, b) => a.userGroupLabel.toLocaleLowerCase().localeCompare(b.userGroupLabel.toLocaleLowerCase()));
    }
}

export class UserGroupsTableRowMember extends BaseModel {
    userId: number;
    username: string;
    isRegistered: boolean;
    firstName?: string;
    lastName?: number;
    startDate?: Date;
    endDate?: Date;

    static __dates = ['startDate', 'endDate'];

    constructor(data) {
        super(data, UserGroupsTableRowMember.__dates);

        this.id = data.userId;
        this.userId = data.userId;
        this.username = data.username;
        this.firstName = data.firstName;
        this.lastName = data.lastName;
        this.startDate = this.__get('startDate');
        this.endDate = this.__get('endDate');
    }
}

export class UserGroupTableRow extends BaseModel {
    userGroupId: number;
    userGroupLabel: string;
    userGroupDescription: string;
    userGroupContractId: number;
    userGroupContractLabel: string;
    userGroupContractStartDate: Date;
    userGroupContractEndDate: Date;
    userGroupContractMembers: UserGroupsTableRowMember[];

    static __dates = ['userGroupContractStartDate', 'userGroupContractEndDate'];

    constructor(data) {
        data['userGroupContractStartDate'] = data['ugcStartDate']
        data['userGroupContractEndDate'] = data['ugcEndDate']
        data['ugcStartDate'] = undefined
        data['ugcEndDate'] = undefined
        super(data, UserGroupTableRow.__dates);

        this.id = data.ugId;
        this.userGroupId = data.ugId;
        this.userGroupLabel = data.ugLabel;
        this.userGroupDescription = data.ugDescription;
        this.userGroupContractId = data.ugcId;
        this.userGroupContractLabel = data.ugcLabel;
        this.userGroupContractStartDate = this.__get('ugcStartDate');
        this.userGroupContractEndDate = this.__get('ugcEndDate');
        let members = data.ugcMembers;
        if (typeof members === 'string') {
            members = JSON.parse(members);
        }
        this.userGroupContractMembers = members?.map((m) => new UserGroupsTableRowMember(m));
    }

    /** Sorter for list of user group contracts that sort by member usernames */
    static memberEmailSort(a: UserGroupTableRow, b: UserGroupTableRow) {
        const amem = a.userGroupContractMembers?.map((m) => m.username).join(' ');
        const bmem = b.userGroupContractMembers?.map((m) => m.username).join(' ');
        return amem.toLocaleLowerCase().localeCompare(bmem.toLocaleLowerCase());
    }

    /** Sort list of user group contracts by date ASC with null last */
    static contractDateSort(a: UserGroupTableRow, b: UserGroupTableRow) {
        const aDate = a.userGroupContractEndDate ?? a.userGroupContractStartDate ?? null;
        const bDate = b.userGroupContractEndDate ?? b.userGroupContractStartDate ?? null;
        if (aDate === null) {
            return bDate === null ? 0 : 1;
        }
        if (bDate === null) {
            return -1;
        }
        return aDate < bDate ? -1 : aDate > bDate ? 1 : 0;
    }
}